import { useTranslation } from 'react-i18next';
import React, { useLayoutEffect, useState } from 'react'
import { getCodeVersion } from '../../utility/service/api-service';
import { Documents } from '../../components/layout/Documents';

export function Footer({isPublic = false}) {
  const { t } = useTranslation();
  const [version,setVersion] = useState('');

  useLayoutEffect(()=>{
    getCodeVersion()
      .then(res=>{
        if(res?.request?.status === 200 || res?.status === 200){
          setVersion(res?.data?.version);
        } 
        
      })
  },[]) 
    return (
      <div className={isPublic ?'layout-bottom':'layout-content-bottom'}>
        {isPublic ? (<Documents></Documents>) :<></>}

        <div className={isPublic ?'layout-main-content-footer':'layout-content-footer'}>
            <span className='version ml-2'>{version}</span>
            <span className='ml-2'>©TPIsoftware. All Rights Reserved.</span>
            <div className='inline-block ml-2'>
              <i className="pi pi-envelope mr-1"></i>
              <a className="link" href="mailto:greenswift@tpisoftware.com">greenswift@tpisoftware.com</a>
            </div>
        </div>
      </div>
    )
}